@if (vibrationRecord() != undefined) {
  <div class="">
    <div class="charts">
    <div class="pb-4 text-size-16 d-flex align-items-center">
      <div>
        <span class="cursor"
              (click)="setTab('signal')"
              [ngClass]="{'highlighted-div': selectedTab() === 'signal'}">
          {{'RECORD.SIGNAL' | translate}}
        </span>

        <span class="ms-4 cursor"
              (click)="setTab('frequency')"
              [ngClass]="{'highlighted-div': selectedTab() === 'frequency'}">
          {{'RECORD.FREQUENCY' | translate}}
        </span>

        <span class="ms-4 cursor"
              (click)="setTab('standard')"
              [ngClass]="{'highlighted-div': selectedTab() === 'standard'}">
          {{'RECORD.STANDARD' | translate}}
        </span>
      </div>

      <button
        type="button"
        class="primary-button ms-4"
        (click)="downloadRecordReport()"
        [disabled]="isDownloadingReport()">
        Report
      </button>
    </div>
      <div [ngStyle]="{'display': selectedTab() === 'signal' ? 'block' : 'none'}">
        @for (a of vibrationRecord()?.signalDataEntity?.signalData?.channels; track a; let i = $index) {
          <div class="chart">
            <div class="row mr-0" >
              <div class="col-3" >
                <div class="border p-1  mt-2 rounded-1">
                  <div class="text-size-14"> {{'RECORD.CHANNEL' | translate}} {{i + 1}}</div>
                  <div class="text-muted text-size-12">
                    {{vibrationRecord().recordMetadata.transducerAxis[i] |
                    formatTransducerType }}
                  </div>
                  <div class="text-muted text-size-12">
                    {{vibrationRecord().recordMetadata.transducerType[i] |
                    formatTransducerType }}
                  </div>
                  <div class="text-size-14">{{'RECORD.RAW' | translate }} :
                    {{findMaxAbsValue(vibrationRecord()?.signalDataEntity?.signalData?.channels[i]?.timeSpectrum.ppvMin,
                    vibrationRecord()?.signalDataEntity?.signalData?.channels[i].timeSpectrum.ppvMax) |
                    number : '1.2-2'}} {{i < 3 ? 'mm/s' : 'Pa'}}
                  </div>
                </div>
              </div>
              <div class="col-9">
                <canvas class="canvas-custom-width" attr.id="canvas-{{i}}" height="50vh"></canvas>
              </div>
            </div>
          </div>
        }
      </div>
      <div [ngStyle]="{'display': selectedTab() === 'frequency' ? 'block' : 'none'}">
        <div class="row mr-0">
          <div class="col-2">
            @for (a of vibrationRecord()?.signalDataEntity?.signalData?.channels; track a; let i = $index) {
              <div
                class="chart">
                @if (i < 3) {
                  <div class="border p-1 rounded-1 mt-2">
                    <div class="text-size-14"> Channel {{i + 1}}</div>
                    <div class="text-muted text-size-12"> {{channelNames[i] | translate }}</div>
                    <div class="text-muted text-size-12"> Pic FFT: {{a.frequencySpectrum.maximumFrequencyHz | number :
                    '1.0-0'}} Hz</div>
                  </div>
                }
              </div>
            }
          </div>
          <div class="col-10 mt-4">
            <canvas id="canvas-fft" class="w-80 h-85"></canvas>
          </div>
        </div>
      </div>
      <div [ngStyle]="{'display': selectedTab() === 'standard' ? 'block' : 'none'}">
        <div class="row-item-width-50 input-container mx-auto d-block pb-2">
          <label class="input-label">{{'RECORD.STANDARD' | translate }}</label>
          <ng-select
                    [items]="standards"
                    bindLabel="code"
                    bindValue="code"
                    [(ngModel)]="selectedStandardCode"
                    placeholder="Select standard"
                    (change)="onStandardChange($event)"
                    [clearable]="true"
                    [searchable]="true"
                    [closeOnSelect]="true">
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.code }}{{ item.country ? ' — ' + item.country : '' }}
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.code }}{{ item.country ? ' — ' + item.country : '' }}
                    </ng-template>
            </ng-select>
        </div>
        @if (standardGraphData?.weightedPpvValues != null) {
          <div class="d-flex flex-wrap gap-3">
            @for (a of localRecord()?.timeSpectrumWeighted; track a; let i = $index) {
              @if (i < 3) {
                <div class="border p-1 mt-2 rounded-1">
                  <div class="text-size-14"> Channel {{i + 1}}</div>
                  <div class="text-muted text-size-12"> {{localRecord().recordMetadata.transducerAxis[i] | formatTransducerType }}</div>
                  <div class="text-muted text-size-12"> {{localRecord().recordMetadata.transducerType[i] | formatTransducerType }}</div>
                  <div class="text-size-14"> {{'RECORD.WEIGHTED' | translate }} :
                    {{abs(localRecord()?.timeSpectrumWeighted[i].ppvMax) | number : '1.2-2'}} mm/s
                  </div>
                </div>
              }
            }
            <div class="border p-1 mt-2 rounded-1 text-size-14">
              <div> PPV Max</div>
              <div> {{findPPVMax(localRecord()?.timeSpectrumWeighted) | number : '1.2-2'}} mm/s</div>
            </div>
          </div>
        }
        @if (standardGraphData && standardGraphData?.weightedPpvValues == null){
        <div style="position: relative; height: 400px;">
                <div class="text-center text-muted mb-2" *ngIf="standardGraphData.standardName">
                    <b>{{ standardGraphData.standardName }}</b>
                </div>
                <canvas id="canvas-compliance" style="width:100%; height:100%;"></canvas>
        </div>
        }

      </div>
    </div>
  </div>
}